import $ from 'jquery';
import 'jquery.cookie';

import { InitUI as GlobalInitUI , IsQuickDepositSite } from 'global/GlobalUI.js';

import 'global/PushNotifications.js';
import { IsMobile, setCookie } from 'global/BrowserUtil.js';
import { btnDivAlerta, btnVerifyAccountStep1 } from 'account/AgeVerification.js';
import { getAccNoFromUV } from 'account/Index.js';
import { IovationChunk } from 'global/Chunks.js';
import { LaunchGame } from 'navigation/QuickLinks.js';

import { InitWebsocket } from 'global/WebSocket';

import MobileAPI from 'app/MobileApi.js';
import MobileApp from 'app/MobileApp.js';


//playtech API
//https://login-games.boylesports.com/jswrapper/integration.js.php?casino=boylesports
import 'external/integration.js';

//CSS
import 'css/base.scss';
import "slick-carousel/slick/slick.scss";
import "css/desktop-media-queries.style.scss";
import "css/modules.style.scss";

async function InitMobileAPI() {
    let isMobile = IsMobile();
    let mobileApp = new MobileApp(navigator.userAgent, isMobile, '');
    let mobileApi = new MobileAPI(mobileApp.isMobile, mobileApp.isIOS, mobileApp.isAndroid);

    mobileApi.SetLoginSessionInfo(window.ModuleConfig.LoginSessionInfo);

    $(function () {
        if (window.location.href.toLowerCase().indexOf("mobilesportsbook/promotions") > -1) {
            mobileApp.setActiveFooterTab('promotions');
            mobileApp.callNativeApp('app_OpenPulsateMenu');
        }
    });
    $(document).on("touchend", "#login-funnel .close-funnel", function (e) {
        e.preventDefault();
        mobileApp.checkIsLoginPopup();
        $('.withdivAVpopup').css('display', '');
        $('#AVDialogStep1').css('display', 'none');
    });

    window.mobileApp = mobileApp;
    window.mobileApi = mobileApi;
}

$(window).on("orientationchange", function () {
    var isIOS = navigator.userAgent.match(/iPhone|Ipad/i) != null;
    if (isIOS) {
        $('.scroll_wrapper#racing-nav').css('width', '100%');
        $('.scroll_wrapper.minimenu-nav').css('width', '100%');
    }
});


//My Bets 4.0 Changes 

$('.scroll_wrapper#bhType').css('width', '100%');

$("#mybets-tab ul li").click(function () {
    // remove classes from all
    $("#mybets-tab ul li").removeClass("active");
    // add class to the one we clicked
    $(this).addClass("active");

});

function InitUV() {
    window.universal_variable = window.universal_variable || {};
    window.universal_variable.page = window.universal_variable.page || {};
    window.universal_variable.user = window.universal_variable.user || {};
    window.universal_variable.basket = window.universal_variable.basket || {};
    window.universal_variable.basket.line_items = window.universal_variable.basket.line_items || [];
    window.universal_variable.basket.total_stake = 0;
    window.universal_variable.basket.total_potential = 0;
    window.universal_variable.basket.tax = 0;
    window.universal_variable.basket.total_bet_number = window.universal_variable.basket.line_items.length;
    window.universal_variable.events = window.universal_variable.events || [];
    window.universal_variable.page = {
        "category": "home",
        "subcategory": "sports-betting",
        "environment": "production"
    };
    if (window.ModuleConfig.LoginSessionInfo.username === null) {
        window.universal_variable.user = {
            "language": "en-gb"
        };
    } else {
        window.universal_variable.user = {
            user_id: window.ModuleConfig.LoginSessionInfo.user_id,
            language: "en-gb",
            account_currency: window.ModuleConfig.LoginSessionInfo.acc_currency_name,
            avstatus: window.ModuleConfig.LoginSessionInfo.avstatus,
            username: window.ModuleConfig.LoginSessionInfo.username,
            firstname: window.ModuleConfig.LoginSessionInfo.firstname,
            holder_id: window.ModuleConfig.LoginSessionInfo.user_account_id,
            acc_no: window.ModuleConfig.LoginSessionInfo.acc_no,
            risk_category: window.ModuleConfig.LoginSessionInfo.risk_category,
            bet_factor: window.ModuleConfig.LoginSessionInfo.bet_factor,
            IdCustomer: window.ModuleConfig.LoginSessionInfo.customer_id,
            currency_notation: window.ModuleConfig.LoginSessionInfo.acc_currency,
            odds_type: window.ModuleConfig.LoginSessionInfo.odds_type,
            email: window.ModuleConfig.LoginSessionInfo.email
        };
    }
}

function InitEGUV() {
    if (window.uv == null) {
        return;
    }
    window.egUser = function () {
        window.uv.emit('egUser', {
            user: window.__eg_user
        });
    };
    window.egUser();

    window.egUserLogin = function () {
        localStorage.removeItem('FireLoginEvent');
        window.uv.emit('egUserLogin', {
            firstLogin: window.__eg_user.firstSession,
            type: "Password",
            user: window.__eg_user
        });
    };

    window.egUserSignUp = function () {
        localStorage.removeItem('FireRegistrationEvent');
        window.uv.emit('egUserSignup', {
            type: "Registration",
            name: "Account_Registration",
            user: window.__eg_user
        });
    };


    if (localStorage.getItem('FireLoginEvent')) {
        window.egUserLogin();
    }
    if (localStorage.getItem('FireRegistrationEvent')) {
        window.egUserSignUp();
    }
}

async function InitExternalScripts() {
    $(function () {
        (function () {
            var _fbq = window._fbq || (window._fbq = []);
            if (!_fbq.loaded) {
                var fbds = document.createElement('script');
                fbds.async = true;
                fbds.src = '//connect.facebook.net/en_US/fbds.js';
                var s = document.getElementsByTagName('script')[0];
                s.parentNode.insertBefore(fbds, s);
                _fbq.loaded = true;
            }
            _fbq.push(['addPixelId', '620366118046897']);
        })();

        window._fbq = window._fbq || [];
        window._fbq.push(['track', 'PixelInitialized', {}]);
    });
}
/**
 * EXPORTS TO WINDOW HERE
 * Use this section to set global window functions.
 * This is the gatekeeper to keep track of whats used externally on the pages
 * DO NOT ADD WINDOW FUNCTIONS FROM INSIDE YOUR MODULES AND CALL THEM FROM HTML
 * THEY MUST BE SET HERE!!
 * 
 * Example:
 * w.AppCode = {
 *  Run: MyModule.Run
 * }
 * 
 * This will allow you to call window.AppCode.Run() externally (or simply AppCode.Run())
 */

window.$ = window.jQuery = $; //export jQuery function to window
if (typeof window.ModuleConfig.gws !== "string" || (typeof window.ModuleConfig.gws === "string" && window.ModuleConfig.gws.length === 0)) {
    window.ModuleConfig.gws = 'ws1.boylesports.com'; //used to pass Web.config values to JS modules here
}
window.decimal = false; //show decimal odds
window.Sports = {};

window.getAccNoFromUV = getAccNoFromUV;

/**
 * Functions used by qubit scripts
 */
window.btnDivAlerta = btnDivAlerta;
window.btnVerifyAccountStep1 = btnVerifyAccountStep1;
window.LaunchGame = LaunchGame;
/**
 * RUN INIT CODE
 */


window.addEventListener('DOMContentLoaded', GlobalInitUI);
InitMobileAPI();
InitUV();

if (!IsQuickDepositSite()) {
    InitWebsocket();
    InitEGUV();
    InitExternalScripts();
}